<template>
  <div id="erasmus_body">
    <div id="title_bar">
      <img :src="require('../assets/erasmus-logo.svg')" />
      <div id="menu">
        <a href="/"><img id="back" :src="require('../assets/back.svg')" /></a>
        <div id="lang_selector">
          <img @click="eng = false" :src="require('../assets/it_flag.svg')" />
          <img @click="eng = true" :src="require('../assets/uk_flag.svg')" />
        </div>
      </div>
    </div>

    <div id="scroll">
      <div id="weeks_selector">
        <h2>Jump to week:</h2>
        <template v-for="n in len">
          <a
            v-bind:title="
              eng
                ? erasmus_weeks[n - 1].title_eng
                : erasmus_weeks[n - 1].title_ita
            "
            v-bind:href="'/erasmus/#week-' + (n - 1)"
            v-bind:key="n - 1"
          >
            <div class="week_selector">{{ n - 1 }}</div>
          </a>
        </template>
      </div>
      <template v-for="elem in erasmus_weeks">
        <div
          v-bind:id="'week-' + elem.id"
          class="week_review"
          v-bind:key="elem.id"
        >
          <p v-if="eng" class="week_review_title">
            <span>WEEK {{ elem.id }} - {{ elem.title_eng }}</span>
          </p>
          <p v-if="!eng" class="week_review_title">
            <span>SETTIMANA {{ elem.id }} - {{ elem.title_ita }}</span>
          </p>
          <div class="week_review_desc">
            <figure v-bind:class="elem.class">
              <a
                v-bind:href="'/erasmus_weeks/week-' + elem.id + '.jpg'"
                target="_blank"
              >
                <img :src="'/erasmus_weeks/week-' + elem.id + '.jpg'" />
              </a>
              <figcaption v-if="eng" v-html="elem.quote_eng"></figcaption>
              <figcaption v-if="!eng" v-html="elem.quote_ita"></figcaption>
            </figure>
            <p v-if="eng" v-html="elem.desc_eng" ></p>
            <p v-if="!eng" v-html="elem.desc_ita" ></p>
          </div>
          <p class="week_review_date">{{ elem.date }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import erasmus_weeks from "../static/erasmus_weeks.js";
export default {
  data() {
    return {
      erasmus_weeks: erasmus_weeks,
      eng: false,
      len: erasmus_weeks.length,
    };
  },
  beforeCreate: function () {
    document.body.style.background = "#00b4d8";
    window.$(document).ready(function () {
      window.$(this).scrollTop(0);
    });
  },
};
</script>

<style>
@font-face {
  font-family: "typewriter";
  src: url("../assets/fonts/typewriter.ttf") format("truetype");
}
@font-face {
  font-family: "belgrano";
  src: url("../assets/fonts/belgrano.ttf") format("truetype");
}

:root{
  --main-brown:#302d36;
}

#scroll {
  width: 800px;
  min-height: 100vh;
  left: 50%;
  position: relative;
  background: white;
  filter: sepia();
  transform: translate(-50%);
  border-right: 2px solid black;
  border-left: 2px solid black;
  border-bottom: 2px solid black;
}
#title_bar {
  position: relative;
  height: fit-content;
  width: 100vw;
  background: yellow;
  border-top: 3px solid rgb(209, 14, 14);
  border-bottom: 3px solid rgb(209, 14, 14);
}

#title_bar img {
  height: 150px;
  text-align: left;
}

#menu {
  position: absolute;
  width: 100px;
  text-align: center;
  right: 50px;
  font-size: 35px;
  bottom: 30px;
}

#back {
  width: 100%;
  height: auto !important;
}

#lang_selector img {
  width: 50px;
  height: auto;
  cursor: pointer;
}

#weeks_selector {
  padding: 10px;
  font-family: belgrano;
}
.week_selector {
  width: 25px;
  line-height: 25px;
  height: 25px;
  display: inline-block;
  font-size: auto;
  text-align: center;
  vertical-align: center;
  border: 3px solid var(--main-brown);
  border-radius: 10px;
  color: var(--main-brown);
  margin: 5px;
}
.week_selector:hover {
  background: aqua;
}
.week_review {
  border: 3px solid var(--main-brown);
  padding: 10px;
  margin: 10px;
  color: var(--main-brown);
}

.week_review_title {
  font-size: 25px;
  color: white;
  filter: sepia();
  padding-left: 5px;
  padding-right: 5px;
  font-family: "typewriter";
}
.week_review_title span {
  background: black;
  padding-left: 5px;
  padding-right: 5px;
}

.week_review_date {
  padding-top: 5px;
  text-align: right;
  font-family: "belgrano";
}

.week_review_desc {
  padding-top: 5px;
  overflow: auto;
  padding-bottom: 5px;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  font-family: "belgrano";
}

.week_review_desc figure {
  text-align: center;
  font-style: italic;
  font-size: smaller;
  filter: sepia();
}

.week_review_desc figure.top {
  width: auto;
}

.week_review_desc figure.left {
  float: left;
  width: 30%;
  padding-right: 10px;
}
.week_review_desc img.landscape-left {
  float: left;
  width: 30%;
  padding-right: 10px;
  padding-top: 5px;
}

.week_review_desc img.portrait-left {
  float: left;
  width: 20%;
  padding-right: 10px;
  padding-top: 5px;
}

.week_review_desc figure.right {
  float: right;
  width: 30%;
  padding-left: 10px;
}

.week_review_desc img.landscape-right {
  float: right;
  width: 30%;
  padding-left: 10px;
  padding-top: 5px;
}

.week_review_desc img.portrait-right {
  float: right;
  width: 20%;
  padding-left: 10px;
  padding-top: 5px;
}

.week_review_desc img {
  width: 100%;
}
.week_review_desc figcaption {
  font-size: 20px;
  font-style: bold;
  font-family: "typewriter";
}

.week_review high {
  color: white;
  background: black;
  font-family: "typewriter";
}

spoiler {
  color: black;
  background: black;
  padding-right: 5px;
}
spoiler:before {
  color: white;
  padding-left: 5px;
  content: "⚠ SPOILER! ⚠ ";
}
spoiler:hover {
  cursor: pointer;
  background: white;
  color: var(--main-brown);
}
spoiler:hover:before{
  color: var(--main-brown);
}
@media (min-width: 320px) and (max-width: 800px) {
  #scroll {
    width: 100vw;
  }
  #menu {
    position: relative;
    right: initial;
    left: 50%;
    display: inline-block;
    bottom: initial;
    padding-bottom: 10px;
    transform: translate(-50%);
  }

  #title_bar img {
    height: auto;
    width: 100%;
  }

  #lang_selector img {
    width: 50px;
  }

  .week_review_desc figure {
    width: auto;
  }
  .week_review_desc figure.right,
  .week_review_desc figure.left {
    width: auto;
    float: none;
    padding: 0px;
  }

  .week_review_desc img,
  .week_review_desc img.portrait-right,
  .week_review_desc img.portrait-left,
  .week_review_desc img.landscape-right,
  .week_review_desc img.landscape-left {
    width: 100%;
    float: none;
    padding: 0px;
  }
}
</style>